import { VideoCard } from 'ui/components/2-molecules/Card/VideoCard';

export const VideoCardFeature: React.FC<Umbraco.VideoCard> = ({ content, settings }) => (
	<VideoCard {...content?.properties} {...settings?.properties} />
);
